import { render } from "./HomePage.vue?vue&type=template&id=64fda29c"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dp11g14\\AppData\\Local\\Temp\\cape-build.867\\core\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__